import { ArrayInput, SimpleFormIterator } from 'react-admin'
import React from 'react'
import { TypedChoices } from 'services/cfg/form'
import PricingRuleIfClauseInputGroup from './PricingRuleIfClauseInputGroup'
import PricingRuleThenClauseInputGroup from './PricingRuleThenClauseInputGroup'
import PricingRulePriceInputGroup from './PricingRulePriceInputGroup'
import { LocationPricingRuleSet } from 'services/api/entities/catalog/location/types/internal/location-models'

export type PricingRulesInputProps = {
  nameChoices: TypedChoices<string | undefined>
  ruleSet?: LocationPricingRuleSet
  source: string
}

const PricingRulesArrayInput: React.FC<PricingRulesInputProps> = ({
  nameChoices,
  ruleSet,
  source,
}) => {
  return (
    <ArrayInput source={source} label="">
      <SimpleFormIterator>
        <PricingRuleIfClauseInputGroup
          ruleSet={ruleSet}
          nameChoices={nameChoices}
        />
        <PricingRuleThenClauseInputGroup />

        <PricingRulePriceInputGroup />
      </SimpleFormIterator>
    </ArrayInput>
  )
}

export default PricingRulesArrayInput
